<template>
    <div class="style">
        <!--弹出框-->
        <el-dialog :title="dialogTitle" :close-on-click-modal=false :visible.sync="dialogVisible" width="400px" :close="handleClose">
            <div class="title">
                <span class="checktip">* </span>系列名称：
                <el-input v-model="dialogData.name" style="width: 230px;" placeholder="系列名称"></el-input>
            </div>
            <div class="flexBox fbTextAGCenter">
                <div>
                    上下架:
                </div>

                <div>
                    <el-select v-model="statusValueChange" placeholder="请选择上下架">
                        <el-option
                                v-for="item in statusType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()">确 定</el-button>
		  </span>
        </el-dialog>

        <div class="dataTag">
            <div class="handle">
                <div class="fl">
                    <img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
                    <span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
                </div>
                <div class="handleBtn fr">
                    <el-button type="primary" size="small" @click="handleAdd">添加</el-button>
                    <el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
                </div>
            </div>
            <!--列表内容-->
            <div class="filtrateMain">
                <el-col :span="18">
                    <div class="flexBox">


                        <div class="flexBox fbTextAGCenter">
                            <div>
                                名称:
                            </div>
                            <div>
                                <el-input v-model="Seriesname"  placeholder="名称"></el-input>
                            </div>
                        </div>
                        <div class="flexBox fbTextAGCenter" style="margin-left: 10px;" >
                            <div>
                                上下架:
                            </div>
                            <div>
                                <el-select v-model="statusValue" placeholder="请选择上下架">
                                    <el-option
                                            v-for="item in statusType"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </el-col>
            </div>
            <div class="search">
                <el-button type="primary" size="mini" @click="handleSearch()">查询</el-button>
                <el-button type="warning" size="mini" @click="handleImgReset()">重置</el-button>
            </div>


            <div class="tableData" style="text-align: center;">
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        border
                        @selection-change="handleSelectionChange"
                        style="width: 100%;border-bottom: 1px solid #ddd;">
                    <el-table-column type="selection" width="150px">
                    </el-table-column>
                    <el-table-column type="index" label="序号" width="100px">
                    </el-table-column>
                    <el-table-column prop="name" label="系列类型" width="250px">
                    </el-table-column>
                    <el-table-column prop="name" label="状态" width="150px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status == 1">
                                上架
                            </div>
                            <div v-else >
                                下架
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a> |
                            <a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--分页-->
            <div class="page">
                <el-pagination
                        background
                        :current-page="tableDataArr.currentPage"
                        :page-sizes="[10,20,30,40]"
                        :page-size="tableDataArr.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableDataArr.totalSize"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </div>


    </div>
</template>

<script>
    import management from './management.vue'
    import navZcy from './nav.vue'
    export default {
        name: "series",
        components:{
            management,navZcy
        },
        data() {
            return {
                statusType:[{
                    value:1,
                    label:"上架",
                },
                    {
                        value:2,
                        label:"下架",
                    }
                ],
                statusValue:'',
                statusValueChange:'',
                dialogTitle: '',
                dialogVisible: false,
                tableData: [],
                dialogData: {},
                multipleSelection: [],
                tableDataArr: {			//分页
                    currentPage: 1,
                    pageSize: 10,
                    totalSize: 0
                },
                Seriesname:'',
            }
        },methods: {
            //弹出框关闭
            handleClose: function(done) {
                done();
            },
            getSeries() {
                const formData = new FormData();
                if(this.Seriesname.length>0){
                    formData.append("name",this.Seriesname)
                }
                formData.append("currentPage",this.tableDataArr.currentPage)
                formData.append("pageSize",this.tableDataArr.pageSize)
                formData.append("status",this.statusValue)

                this.$fly.post("zcvrVideoApi/imgList/getSeriesFromDB/"+sessionStorage.getItem('sessionId'),formData).then(
                    (success)=>{
                        if(success.data.msg!="ok"){
                            this.tableData = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            console.log("success.data:",success.data)
                            this.tableDataArr = success.data.data
                            if(this.tableDataArr.items){
                                this.tableData = this.tableDataArr.items
                            }else{
                                this.tableData = []
                            }
                        }

                    },
                    (error)=>{
                        console.log("数据连接失败")
                    })
            },
            //添加图片风格
            handleAdd: function() {
                this.dialogTitle = "添加系列类型";
                this.dialogData={
                    name: ""
                };
                this.statusValueChange="上架"
                this.dialogVisible = true;
                setTimeout(function(){
                    $('.input').focus()
                },100)
            },
            //编辑图片风格
            handleEdit: function(index, row) {
                this.dialogTitle = "编辑系列类型";
                this.dialogData = {
                    id: row.id,
                    name: row.name
                };
                this.dialogVisible = true;
                this.statusValueChange = row.status
                setTimeout(function(){
                    $('.input').focus()
                },100)
            },
            //确定添加/编辑
            handleConfirm: function() {
                if(this.dialogData.name){
                    let url = ""
                    const formData = new FormData();
                    formData.append("name",this.dialogData.name)
                    console.log("statusValueChange",this.statusValueChange)
                    if(this.statusValueChange=="上架"){
                        formData.append('status',1)
                    }else{
                        formData.append('status',this.statusValueChange)
                    }
                    if(this.dialogTitle == "添加系列类型"){
                        url = "zcvrVideoApi/imgList/createSeries/"+sessionStorage.getItem('sessionId')
                    }else{
                        url = "zcvrVideoApi/imgList/updateSeries/"+sessionStorage.getItem('sessionId')
                        formData.append("id",this.dialogData.id)
                    }
                    this.$fly.post(url,formData).then(
                        (success)=>{
                            console.log(success)
                            if(success.data.msg!="ok"){
                                this.$message({
                                    type: 'error',
                                    message: success.data.msg
                                });
                                if(success.data.msg=="该SessionId已经超时"){
                                    this.$message.error("登录超时！请重新登录");
                                    this.$router.push({path: '/',query: ''})
                                }
                            }else {
                                this.dialogVisible = false
                                this.getSeries()
                            }
                        },
                        (error)=>{
                            console.log("数据连接失败")
                        })
                }else{
                    this.$message({
                        type: 'error',
                        message: '请输入系列类型名称'
                    });
                }
            },
            //复选框选中
            handleSelectionChange: function(val){
                this.multipleSelection=[]
                for (let i=0; i<val.length; i++) {
                    this.multipleSelection.push(val[i].id)
                }
            },
            //删除图片风格
            handleDelete: function(index, row) {
                let id = []
                if(row!=0){
                    id[0] = row.id
                }else{
                    id = this.multipleSelection
                }
                if(id.length>0){
                    this.$confirm('此操作将永久删除该系列, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let url = "zcvrVideoApi/imgList/deleteSeries/"+sessionStorage.getItem('sessionId')+"/"+id
                        this.$http.get(url,{emulateJson:true}).then(
                            (success)=>{
//				  				console.log(success)
                                if(success.body.msg=="ok"){
                                    this.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getSeries()
                                }else{
                                    this.$message({
                                        message: success.data.msg,
                                        type: 'error'
                                    });
                                    if(success.data.msg=="该SessionId已经超时"){
                                        this.$message.error("登录超时！请重新登录");
                                        this.$router.push({path: '/',query: ''})
                                    }
                                }
                            },
                            (error)=>{
                                console.log("数据连接失败")
                            }
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '请选择删除项'
                    });
                }
            },
            //点击页数
            handleCurrentChange(cur) {
                this.tableDataArr.currentPage = cur
                this.getSeries()
            },
            //点击改变显示条目
            handleSizeChange(size) {
                this.tableDataArr.pageSize = size
                this.getSeries()
            },
            handleSearch(){
                this.getSeries()
            },
            handleImgReset(){
                this.Seriesname = ''
                this.statusValue=''
                this.getSeries()
            }
        },
        mounted() {
            this.getSeries()
        },
    }
</script>

<style scoped>
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .page{
        text-align: center;
    }
    .filtrateMain{
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .search{
        padding-left: 200px;
        padding-bottom: 15px;
    }


</style>
